import { StyleSheet } from 'react-native';
import { Spacing } from 'src/theme-v2/spacing';

export const styles = StyleSheet.create({
  pressTooltipContentWrapper: {
    paddingVertical: Spacing.Compact,
    paddingLeft: Spacing.Compact,
    paddingRight: Spacing.Condensed,
    flexDirection: 'row',
  },
});
